import React, { useEffect } from 'react'
import { connect } from 'react-redux';

import * as actions from '../../store/actions/index';
import Text from '../../components/Text/Text';
import './InterestingLinks.css';

const InterestingLinks = props => {
  const { getInterestingLinks } = props;

  useEffect(() => {
    getInterestingLinks();
  }, [getInterestingLinks]);

  return (
    <div className='bg-white rounded'>
        <h2 className='font-serif text-base font-bold px-4 pb-2 pt-3 border-solid border-b-2'>Enlaces de interés</h2>
      <div className='p-6'>
        <Text><div className='interesting-links text-grey-darker' dangerouslySetInnerHTML={{ __html: props.interestingLinks }} /></Text>
      </div>
    </div>
  )
}

const mapsStateToProps = state => {
  return {
    interestingLinks: state.interestingLinks
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getInterestingLinks: () => dispatch(actions.getInterestingLinks())
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(InterestingLinks);
